import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeviceComponent } from './components/device/device.component';
import { GlobalComponent } from './components/global/global.component';

import { StatisticsComponent } from './statistics.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    component: StatisticsComponent,
    children:[
      {
        path: '',
        redirectTo: 'global',
        pathMatch: 'full'
      },
      {
        path:'global',
        component:GlobalComponent
      },
      {
        path:'device/:id',
        component:DeviceComponent
      }

    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StatisticsRoutingModule { }
